var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionArrowsmallDown = function SvgGeneralActionArrowsmallDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    stroke: "#4C4C4C",
    strokeLinejoin: "round",
    d: "M18.125 9.971 12 16.375 5.875 9.971l.637-.596L12 15.113l5.489-5.738z"
  })));
};
export default SvgGeneralActionArrowsmallDown;